var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.isContentReady
      ? _c(
          "div",
          [
            _c(
              "header",
              { staticClass: "row m-team__header" },
              [
                _c("macro-title", {
                  attrs: {
                    title: _vm.rawTitle,
                    "add-class": "m-team__title h2 font-weight-bold"
                  }
                }),
                _vm._v(" "),
                _vm.rawGroupParsed.length !== 1
                  ? [
                      _vm.isMobileAndTouch
                        ? [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedGroup,
                                    expression: "selectedGroup"
                                  }
                                ],
                                staticClass: "select--filter",
                                attrs: { name: "teamGroup", id: "teamGroup" },
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.selectedGroup = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  }
                                }
                              },
                              _vm._l(_vm.filters, function(group) {
                                return _c(
                                  "option",
                                  { domProps: { value: group.term_id } },
                                  [_vm._v(_vm._s(group.name))]
                                )
                              }),
                              0
                            )
                          ]
                        : [
                            _vm.filters && _vm.filters.length > 0
                              ? _c("multiselect", {
                                  staticClass:
                                    "multiselect--regular multiselect--filter",
                                  attrs: {
                                    options: _vm.filters,
                                    label: "name",
                                    placeholder: "",
                                    "track-by": "term_id"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "singleLabel",
                                        fn: function(ref) {
                                          var option = ref.option
                                          return [
                                            _c("span", {
                                              domProps: {
                                                innerHTML: _vm._s(option.name)
                                              }
                                            })
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    3932970321
                                  ),
                                  model: {
                                    value: _vm.selectedObject,
                                    callback: function($$v) {
                                      _vm.selectedObject = $$v
                                    },
                                    expression: "selectedObject"
                                  }
                                })
                              : _vm._e()
                          ]
                    ]
                  : _vm._e()
              ],
              2
            ),
            _vm._v(" "),
            _vm._l(_vm.teamMemberSelection, function(group) {
              return _c("div", { staticClass: "m-team__group" }, [
                _c("h3", {
                  staticClass: "team__category font-weight-bold",
                  domProps: { innerHTML: _vm._s(group.name) }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row row--grid" },
                  _vm._l(group.entries, function(item) {
                    return _c(
                      "div",
                      { staticClass: "col col-sm-12 col-md-6 col-lg-3 team" },
                      [
                        item.feature[0]
                          ? _c(
                              "figure",
                              { staticClass: "figure figure--square" },
                              [
                                _c("div", { staticClass: "figure__inner" }, [
                                  _c("picture", [
                                    _c("img", {
                                      staticClass: "lazyload",
                                      attrs: {
                                        src: item.feature[0],
                                        width: "360",
                                        height: "360",
                                        alt: item.post_title,
                                        loading: "lazy"
                                      }
                                    })
                                  ])
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "team__content" }, [
                          _c("p", [
                            _c(
                              "strong",
                              { staticClass: "font-color-secondary" },
                              [_vm._v(_vm._s(item.post_title))]
                            ),
                            _c("br"),
                            _c("strong", [_vm._v(_vm._s(item.job_title))])
                          ]),
                          _vm._v(" "),
                          _c(
                            "p",
                            { staticClass: "team__info-box" },
                            [
                              item.telefon
                                ? [
                                    _vm._v("\n                T: "),
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href:
                                            "tel:" +
                                            item.telefon.replace(/ /g, "")
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "action__text" },
                                          [_vm._v(_vm._s(item.telefon))]
                                        )
                                      ]
                                    ),
                                    _c("br")
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              item.mobile
                                ? [
                                    _vm._v("\n                M: "),
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href:
                                            "tel:" +
                                            item.mobile.replace(/ /g, "")
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "action__text" },
                                          [_vm._v(_vm._s(item.mobile))]
                                        )
                                      ]
                                    ),
                                    _c("br")
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              item.email
                                ? _c(
                                    "a",
                                    { attrs: { href: "mailto:" + item.email } },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "action__text" },
                                        [_vm._v(_vm._s(item.email))]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.email || item.mobile || item.telefon
                                ? [
                                    _c("br"),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "action action--bordered action--bordered-small action--download action--vcard",
                                        attrs: {
                                          target: "_blank",
                                          href:
                                            "/wp-json/autoag/v1/vcard/" +
                                            item.id
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "action__text" },
                                          [_vm._v("vCard")]
                                        )
                                      ]
                                    )
                                  ]
                                : _vm._e()
                            ],
                            2
                          )
                        ])
                      ]
                    )
                  }),
                  0
                )
              ])
            })
          ],
          2
        )
      : _c("div", [
          _c(
            "header",
            {
              staticClass: "row m-team__header",
              staticStyle: { "max-width": "638px" }
            },
            [
              _c("content-loader", {
                staticClass: "m-team__title",
                attrs: {
                  height: 60,
                  width: 638,
                  speed: 2,
                  primaryColor: "#f3f3f3",
                  secondaryColor: "#ecebeb"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "row row--grid" },
            _vm._l(8, function(i) {
              return _c("content-loader", {
                key: "loader-" + i,
                staticClass: "col col-sm-12 col-md-6 col-lg-3 team",
                attrs: {
                  height: 608,
                  width: 362,
                  speed: 2,
                  primaryColor: "#f3f3f3",
                  secondaryColor: "#ecebeb"
                }
              })
            }),
            1
          )
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }